import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { UiKitContextProvider } from '@cian/ui-kit/context';

import { getIsAnonymous } from '../../../selectors/newReview';
import { setIsAnonymous } from '../../../actions/newReview/isAnonymousActions';
import { Anonymous } from '../../../components/NewReviewModal/parts/Anonymous';

export const AnonymousContainer = () => {
  const dispatch = useDispatch();
  const isAnonymous = useSelector(getIsAnonymous);

  const onClick = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      dispatch(setIsAnonymous(value));
    },
    [dispatch, setIsAnonymous],
  );

  return (
    <UiKitContextProvider useStaticDeviceType={true} deviceType="desktop">
      <Anonymous>
        <Checkbox label="Анонимный отзыв" checked={isAnonymous} onChange={onClick} />
      </Anonymous>
    </UiKitContextProvider>
  );
};
